const Header = ({isApproved}) => {
    return (
        <div className="card card-body" id="profile">
            <div className="row align-items-center justify-content-between">
                {/* Avatar and Title Section */}
                <div className="d-flex align-items-center col-sm-auto col-8">
                    <div className="avatar avatar-xl position-relative me-3">
                        <img
                            src="/assets/img/instafix-favicon.png"
                            alt="profile"
                            className="w-100"
                        />
                    </div>
                    <div>
                        <h5 className="mb-1 font-weight-bolder">
                            {process.env.REACT_APP_SYSTEM_NAME}
                        </h5>
                        <p className="mb-0 font-weight-normal text-sm">
                            {isApproved ? "Your account has been approved, but you cannot view your details yet." : "Let's get your profile set up to join the INSTAFIX team."}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;